<template>
	<div class="about hero is-black is-fullheight">
		<div class="hero-body" id="about">
			<div class="container">
					<!--<div class="col is-half-desktop">
						<swiper
							ref="profileSwiper"
							:options="{
								autoplay: {
									delay: 5000
								}
							}"
						>
							<swiper-slide v-for="(image, index) in list" :key="index">
								<img :src="image.url" />
							</swiper-slide>
						</swiper>
          </div>-->
					<div class="col">
            <img src="../assets/logos.png" style="width: 150px; height: auto; ;" class="is-block">
						<div class="hero">
              <div class="hero-content">
                Love for the music came at his early sweet seventeen.  The starting point of his career was at the RADIO TV EPZ on the island of Zakinthos, Greece. His music inspiration came from artists such as:</br>
                <b>Little Loui Vega, Joey Negro, Moodymann, Kruder & Dorfmeister, Kevin Yost, Saint Germain, Thievery Corporation, Massive Attack, Moby, and many many more!</b>
                He was a producer and animator of the Radio Show called “NO NAME” on Radio EPZ 88.5fm in Zakynthos Greece. During those two years he succeeded as a DJ and got his first residence at the Playboy Night Club in Zakynthos, followed by the second residency at the Cameo Club, then soon after in Athens, Yll Megi started spinning at Studio Bay Queen and Dhites Club.
                Something told him that he should check out the scene in his native country of Albania, which turned out to be a good decision! Downtown Tirana in the early 2000’s was the right place to be for many up and coming artists, the energy and passion was blooming for house music, giving him the experience to cooperate with most of the bars and clubs the city had to offer at the time and especially the south of Albania, where beach clubs were absolutely the favourite destination for all the party goers. He made great connections with people from neighbouring  Kosovo, which led him to negotiating new gigs at Clubs, Festivals and local Radios & TV shows.
                Ylli is one of the most amazing & sophisticated selectors in the region for sure. His positive energy & smile complements his work superbly. From the beach party's to a high snow mountain, he's music makes sense and is a perfect fit every single time. It’s a real treat to see this man behind the booth.
                He cooperated with names such as: <b>Radio TV EPZ (GR), Radio Travel (AL), Radio Urban FM (KS), Klan Kosova TV, RTK1 TV, Hamam Jazz Bar, Dam Festival, PriFilm Festival, SkenaUp Festival, Kosovo 2.0, Prishtina Music Festival, Sunny Hill Festival, Street Party Prishtina, PRite N’shesh, Record Store Day Tirana, Turtle Fest, Spray Club, Tabu Club (AL), Summer Bamboo May Fest, Dolcinium Kite Surf Club, Kasheme (Zürich), Zone Club (PR) and MHz Bar Klub!</b>
                His music style can be described as a twist of Soul, Jazz, Funk, House and Electronic Disco.
                In his recent years YLL MEGI had the pleasure of playing along side with some of the worlds acclaimed producers and Dj’s; to name a few: 
                <b>Peter Kruder, Mike Huckaby, David Alvarado, Orlando Voorn, Dave Mothersole, Eddy Ramich, Love Birds, Tyrrell, Sabb, Gregster Brown, Ad Disha, Ali Kuru, Gentian Rizaj aka Secret 47, Collective Machine, Yacine, Mr, Cool, Noki, Nick Mazrekaj aka Soulmate, Lekë, Jehone, Oda Haliti aka ODA, Marien Baker,</b> any many more!
                <br>
                Enjoy YLLMEGI’S mixes!<br>
                <a href="http://www.mixcloud.com/yllmegi/" target="_blank">Mixcloud</a> | <a href="http://dj.beatport.com/yllmegi" target="_blank">Beatport</a>
                  <br>
                  <br>
              </div>
            </div>
            <img src="../assets/signature.png" style="height: 100px; width: auto; position: relative; bottom: -50px;" class="is-block is-pulled-right">
          </div>
        </div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			list: [
				{ title: "", url: "profile/0001.jpg" },
				{ title: "", url: "pictures/0002.jpg" },
				{ title: "", url: "pictures/0003.jpg" },
				{ title: "", url: "pictures/0004.jpg" },
				{ title: "", url: "pictures/0005.jpg" },
				{ title: "", url: "pictures/0006.jpg" },
				{ title: "", url: "pictures/0007.jpg" },
				{ title: "", url: "pictures/0008.jpg" },
				{ title: "", url: "pictures/0009.jpg" },
				{ title: "", url: "pictures/0010.jpg" },
				{ title: "", url: "pictures/0011.jpg" },
				{ title: "", url: "pictures/0012.jpg" },
				{ title: "", url: "pictures/0013.jpg" },
				{ title: "", url: "pictures/0014.jpg" }
			]
		}
	}
}
</script>
<style scoped>
.hero {
	background: rgba(0, 0, 0, 0.4);
	padding: 0;
}
.hero-body {
	padding: 0.4rem 1.5rem;
}
.is-bold {
	font-weight: bold;
}
</style>
